import {Browser} from '@clappr/core'
import styles from './styles.scss'

const playNextAttribute = Browser.isMobile ? '' : 'data-play-next-hover'

export default `<div class="${styles.loading} eplayer-skin-fullsize">
  <div class="${styles.loadingSpinner} ${styles.spinner}">
    <svg
      class="${styles.loadingSpinnerIcon} ${styles.spinnerIcon}"
      xmlns="http://www.w3.org/2000/svg"
      viewbox="0 0 110 110"
    >
      <circle class="${styles.spinnerCircle}" cx="55" cy="55" r="50" />
      <circle class="${styles.loadingSpinnerProgress} ${styles.spinnerProgress}" cx="55" cy="55" r="50" />
    </svg>
  </div>
</div>
<div
class="
  ${styles.controlsContainer}
  eplayer-skin-component eplayer-holdable eplayer-hide-control-start
"
>
<div class="${styles.controls}">
  <div class="${styles.controlsLeft} ${styles.controlsList}">
    <span class="${styles.playButton} ${styles.controlsItem} ${styles.button}" data-toggle-play>
      <svg
        class="${styles.playIcon} ${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M20 0v20M0 0v20m17.48-9.13L6.5 17.15a1 1 0 0 1-1.5-.87V3.72a1 1 0 0 1 1.5-.87l10.98 6.28a1 1 0 0 1 0 1.74"
        />
      </svg>
      <svg
        class="${styles.pauseIcon} ${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M20 0v20M0 0v20m15-4V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m-7 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1"
        />
      </svg>
      <svg
        class="${styles.replayIcon} ${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M0 20V0m20 20V0M4.62 8.81a5.51 5.51 0 0 0 4.9 6.67.5.5 0 0 1 .48.5v.5a.5.5 0 0 1-.52.5A7 7 0 0 1 10 3c2.3 0 4.33 1.12 5.6 2.84V3.5a.5.5 0 0 1 .5-.5h.4a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-4a.5.5 0 0 1-.5-.5v-.4a.5.5 0 0 1 .5-.5h1.8a5.48 5.48 0 0 0-5.36-2 5.5 5.5 0 0 0-4.31 4.21"
        />
      </svg>
    </span>
    <span class="${styles.playNext} ${styles.controlsItem} ${styles.button}" data-play-next style="display:none">
      <span class="${styles.playNextInner}" ${playNextAttribute}>
        <svg
          class="${styles.buttonIcon}"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M19.5 0v20M.5 0v20M18 16V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1zm-6.11-5.19-8.3 6.03A1 1 0 0 1 2 16.03V3.96a1 1 0 0 1 1.59-.81l8.3 6.04a1 1 0 0 1 0 1.62z"
          />
        </svg>
      </span>
    </span>
    <div class="${styles.volume} ${styles.controlsItem}">
      <div class="${styles.volumeControl}" data-volume>
        <div class="${styles.volumeLevel}">
          <div class="${styles.volumeBar}" data-volume-bar></div>
        </div>
      </div>
      <div class="${styles.button}" data-mute>
        <svg
          class="${styles.volumeHighIcon} ${styles.buttonIcon}"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M8.72 16.72 5 13H2.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H5l3.72-3.72a.75.75 0 0 1 1.28.53V16.2a.75.75 0 0 1-1.28.53zM20 0v20V0zM0 0v20V0zm12 4.53c0-.29.24-.53.53-.5a6 6 0 0 1 0 11.95.5.5 0 0 1-.53-.5v-.8c0-.27.2-.48.47-.5A4.2 4.2 0 0 0 16.2 10a4.2 4.2 0 0 0-3.73-4.17c-.26-.03-.47-.24-.47-.5v-.8zm0 6.89c0 .32.31.58.62.48a2 2 0 0 0 0-3.8c-.3-.1-.62.16-.62.48v2.84z"
          />
        </svg>
        <svg
          class="${styles.volumeMuteIcon} ${styles.buttonIcon}"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 20 20"
        >
          <path
            d="M20 0v20M0 0v20M19.35 7.35l-.7-.7a.5.5 0 0 0-.71 0L16 8.59l-1.94-1.94a.5.5 0 0 0-.7 0l-.71.7a.5.5 0 0 0 0 .71L14.59 10l-1.94 1.94a.5.5 0 0 0 0 .7l.7.71a.5.5 0 0 0 .71 0L16 11.41l1.94 1.94a.5.5 0 0 0 .7 0l.71-.7a.5.5 0 0 0 0-.71L17.41 10l1.94-1.94a.5.5 0 0 0 0-.7M8.72 16.71 5 13H2.5a.5.5 0 0 1-.5-.5v-5a.5.5 0 0 1 .5-.5H5l3.72-3.72a.75.75 0 0 1 1.28.53V16.2a.75.75 0 0 1-1.28.53"
          />
        </svg>
      </div>
    </div>
    <% if (live) { %>
    <div class="${styles.liveButton} ${styles.button} ${styles.controlsItem}" data-live>
      <div class="${styles.liveButtonText}">
        <span>Live</span>
        <div class="${styles.buttonText}"><%= i18n.live_back_to %></div>
      </div>
    </div>
    <% } %>
    <div class="${styles.controlledProgessBar}" data-seek>
      <% episodes.forEach(function (episode) { %>
      <div class="${styles.controlledProgessBarEpisode}" data-seek-episode style="--episode-start: <%= episode.start %>; --episode-end: <%= episode.end %>">
        <div class="${styles.controlledProgessBarTrack}"></div>
      </div>
      <% }) %>
      <span class="${styles.controlledProgessBarThumb}"></span>
    </div>
  </div>
  <div class="${styles.controlsRight} ${styles.controlsList}">
    <div class="${styles.timeinfo}">
      <span class="${styles.timeinfoCurrent}">
        <span class="${styles.timeinfoValue}" data-time-current>00:00</span>
        <span class="${styles.timeinfoPlaceholder}" data-time-placeholder>00:00</span>
      </span>
      <span class="${styles.timeinfoTotal}">
        <span class="${styles.timeinfoValue}" data-time-total>00:00</span>
        <span class="${styles.timeinfoPlaceholder}" data-time-placeholder>00:00</span>
      </span>
      <span class="${styles.timeinfoLeft}">
        <span class="${styles.timeinfoValue}" data-time-left>00:00</span>
        <span class="${styles.timeinfoPlaceholder}" data-time-placeholder>00:00</span>
      </span>
    </div>
    <div class="${styles.shareButton} ${styles.controlsItem} ${styles.button}" data-share>
      <svg
        class="${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M20 0v20M0 0v20m14-8a2.98 2.98 0 0 0-2.17.94L7.9 10.75c.07-.24.11-.49.11-.75s-.04-.5-.1-.75l3.93-2.19A2.98 2.98 0 0 0 14 8a3 3 0 1 0-3-3c0 .26.04.5.1.75L7.18 7.94A2.98 2.98 0 0 0 5 7a3 3 0 1 0 0 6 2.98 2.98 0 0 0 2.17-.94l3.94 2.19A3 3 0 0 0 11 15a3 3 0 1 0 3-3M5 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0-10a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
        />
      </svg>
      <div class="${styles.buttonText}"><%= i18n.share %></div>
    </div>

    <div class="${styles.levelsButton} ${styles.controlsItem} ${styles.button}" data-menu="levels">
      <svg
        class="${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M0 20V0m20 0v20m-10-8.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M10 2a8 8 0 0 0-2.33.35.98.98 0 0 0-.67.94v.94l-.5.29-.8-.47a1.02 1.02 0 0 0-1.21.16 7.98 7.98 0 0 0-2.26 3.9 1.02 1.02 0 0 0 .47 1.14l.81.47v.56l-.81.47a1.02 1.02 0 0 0-.47 1.14 7.98 7.98 0 0 0 2.26 3.9c.33.31.82.38 1.21.16l.8-.47.5.29v.94c0 .42.26.82.67.94a8 8 0 0 0 4.66 0c.4-.12.67-.52.67-.94v-.94l.5-.29.8.47c.4.22.88.15 1.21-.16a7.98 7.98 0 0 0 2.26-3.9 1.02 1.02 0 0 0-.47-1.14l-.81-.47v-.56l.81-.47c.4-.23.57-.7.47-1.13a7.98 7.98 0 0 0-2.26-3.9 1.02 1.02 0 0 0-1.21-.17l-.8.47-.5-.28v-.95a.98.98 0 0 0-.67-.94A8 8 0 0 0 10 2m0 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-9.5c.51 0 1.01.06 1.5.17v1.14c0 .18.1.35.25.44l1.5.86a.5.5 0 0 0 .5 0l.97-.57a6.43 6.43 0 0 1 1.5 2.6l-.98.57a.5.5 0 0 0-.25.43v1.72a.5.5 0 0 0 .25.43l.98.57a6.43 6.43 0 0 1-1.5 2.6l-.98-.57a.5.5 0 0 0-.5 0l-1.49.87a.5.5 0 0 0-.25.43v1.14a6.54 6.54 0 0 1-3 0v-1.14a.5.5 0 0 0-.25-.43l-1.5-.87a.5.5 0 0 0-.5 0l-.97.57a6.43 6.43 0 0 1-1.5-2.6l.98-.57a.5.5 0 0 0 .25-.43V9.14a.5.5 0 0 0-.25-.43l-.98-.57a6.43 6.43 0 0 1 1.5-2.6l.98.57a.5.5 0 0 0 .5 0l1.49-.87a.5.5 0 0 0 .25-.43V3.67c.49-.11.99-.17 1.5-.17"
        />
      </svg>
      <div class="${styles.buttonText}"><%= i18n.quality %></div>
    </div>
    <div class="${styles.ratesButton} ${styles.controlsItem} ${styles.button}" data-menu="rates">
      <svg
        class="${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M10 3a8 8 0 0 1 6.245 13h-2.091a6.5 6.5 0 1 0-8.307 0H3.754A8 8 0 0 1 10 3zm2.758 4.182a.3.3 0 0 1 .424 0l.636.636a.3.3 0 0 1 0 .424l-1.233 1.234a3 3 0 1 1-1.06-1.06h-.001zM10 9.5a1.5 1.5 0 1 0 0 3 1.5 1.5 0 0 0 0-3zM.5 0v20m19-20v20"
        />
      </svg>
      <div class="${styles.buttonText}"><%= i18n.speed %></div>
    </div>
    <div class="${styles.subtitlesButton} ${styles.controlsItem} ${styles.button}" data-menu="subtitles">
      <svg
        class="${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M2 5v11c0 .6.4 1 1 1h14c.6 0 1-.4 1-1V5c0-.6-.4-1-1-1H3c-.6 0-1 .4-1 1zm14.5 10.5h-13v-10h13v10zm-2-4.7h-9c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h9c.3 0 .5.2.5.5v.5c0 .2-.2.5-.5.5zm-5 3h-4c-.3 0-.5-.2-.5-.5v-.5c0-.3.2-.5.5-.5h4c.3 0 .5.2.5.5v.5c0 .2-.2.5-.5.5zm3-1.6h2c.3 0 .5.2.5.5v.5c0 .3-.2.5-.5.5h-2c-.3 0-.5-.2-.5-.5v-.5c0-.2.2-.5.5-.5zM0 0v20V0zm20 0v20V0z"
        />
      </svg>
      <div class="${styles.buttonText}"><%= i18n.subtitles %></div>
    </div>
    <div class="${styles.menuButton} ${styles.controlsItem} ${styles.button}" data-menu="menu">
      <svg
        class="${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M0 20V0m20 0v20m-10-8.5a1.5 1.5 0 1 1 0-3 1.5 1.5 0 0 1 0 3M10 2a8 8 0 0 0-2.33.35.98.98 0 0 0-.67.94v.94l-.5.29-.8-.47a1.02 1.02 0 0 0-1.21.16 7.98 7.98 0 0 0-2.26 3.9 1.02 1.02 0 0 0 .47 1.14l.81.47v.56l-.81.47a1.02 1.02 0 0 0-.47 1.14 7.98 7.98 0 0 0 2.26 3.9c.33.31.82.38 1.21.16l.8-.47.5.29v.94c0 .42.26.82.67.94a8 8 0 0 0 4.66 0c.4-.12.67-.52.67-.94v-.94l.5-.29.8.47c.4.22.88.15 1.21-.16a7.98 7.98 0 0 0 2.26-3.9 1.02 1.02 0 0 0-.47-1.14l-.81-.47v-.56l.81-.47c.4-.23.57-.7.47-1.13a7.98 7.98 0 0 0-2.26-3.9 1.02 1.02 0 0 0-1.21-.17l-.8.47-.5-.28v-.95a.98.98 0 0 0-.67-.94A8 8 0 0 0 10 2m0 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6m0-9.5c.51 0 1.01.06 1.5.17v1.14c0 .18.1.35.25.44l1.5.86a.5.5 0 0 0 .5 0l.97-.57a6.43 6.43 0 0 1 1.5 2.6l-.98.57a.5.5 0 0 0-.25.43v1.72a.5.5 0 0 0 .25.43l.98.57a6.43 6.43 0 0 1-1.5 2.6l-.98-.57a.5.5 0 0 0-.5 0l-1.49.87a.5.5 0 0 0-.25.43v1.14a6.54 6.54 0 0 1-3 0v-1.14a.5.5 0 0 0-.25-.43l-1.5-.87a.5.5 0 0 0-.5 0l-.97.57a6.43 6.43 0 0 1-1.5-2.6l.98-.57a.5.5 0 0 0 .25-.43V9.14a.5.5 0 0 0-.25-.43l-.98-.57a6.43 6.43 0 0 1 1.5-2.6l.98.57a.5.5 0 0 0 .5 0l1.49-.87a.5.5 0 0 0 .25-.43V3.67c.49-.11.99-.17 1.5-.17"
        />
      </svg>
      <div class="${styles.buttonText}"><%= i18n.settings %></div>
    </div>

    <span
      class="${styles.fullscreenButton} ${styles.controlsItem} ${styles.button}"
      data-fullscreen
    >
      <svg
        class="${styles.buttonIcon}"
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 20 20"
      >
        <path
          d="M20 0v20V0ZM0 0v20V0Zm3.5 16.5v-4c0-.3-.2-.5-.5-.5h-.5c-.3 0-.5.2-.5.5V17c0 .6.4 1 1 1h4.5c.3 0 .5-.2.5-.5V17c0-.3-.2-.5-.5-.5h-4Zm13-13v4c0 .3.2.5.5.5h.5c.3 0 .5-.2.5-.5V3c0-.6-.4-1-1-1h-4.5c-.3 0-.5.2-.5.5V3c0 .3.2.5.5.5h4Zm-13 0h4c.3 0 .5-.2.5-.5v-.5c0-.3-.2-.5-.5-.5H3a1 1 0 0 0-1 1v4.5c0 .3.2.5.5.5H3c.3 0 .5-.2.5-.5v-4ZM17 12h.5c.3 0 .5.2.5.5V17c0 .6-.4 1-1 1h-4.5a.5.5 0 0 1-.5-.5V17c0-.3.2-.5.5-.5h4v-4c0-.3.2-.5.5-.5Z"
        />
      </svg>
    </span>
  </div>
</div>
</div>
<div class="${styles.thumbnails} eplayer-skin-component eplayer-skin-fullsize eplayer-skin-shiftable" data-thumbnails>
  <div class="${styles.thumbnailsImage}">
    <div class="${styles.thumbnailsSprite}" data-thumbnails-sprite></div>
    <div class="${styles.thumbnailsTime}" data-thumbnails-time>00:00</div>
  </div>
  <div class="${styles.thumbnailsEpisode}" data-episode-label></div>
</div>
<div class="${styles.progressBar} eplayer-hide-control-start" data-progress></div>
<div
class="
  ${styles.gradientTop} ${styles.gradient}
  eplayer-holdable eplayer-hide-control-start
"
></div>
<div
class="
  ${styles.gradientBottom} ${styles.gradient}
  eplayer-holdable eplayer-hide-control-start
"
></div>
<div
class="
  ${styles.title}
  eplayer-hide-control-start eplayer-holdable eplayer-skin-component
"
>
<div class="${styles.titleInner}" data-title></div>
</div>
<div
class="${styles.largePlay} eplayer-skin-fullsize eplayer-holdable"
data-toggle-play
data-three-sixty
>
  <svg
    class="${styles.largePlayIcon} ${styles.playIcon}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M20 0v20M0 0v20m17.48-9.13L6.5 17.15a1 1 0 0 1-1.5-.87V3.72a1 1 0 0 1 1.5-.87l10.98 6.28a1 1 0 0 1 0 1.74"
    />
  </svg>
  <svg
    class="${styles.largePlayIcon} ${styles.pauseIcon}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 20 20"
  >
    <path
      d="M20 0v20M0 0v20m15-4V4a1 1 0 0 0-1-1h-2a1 1 0 0 0-1 1v12a1 1 0 0 0 1 1h2a1 1 0 0 0 1-1m-7 1H6a1 1 0 0 1-1-1V4a1 1 0 0 1 1-1h2a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1"
    />
  </svg>
  <svg
    class="${styles.largePlayIcon} ${styles.replayIcon}"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 100 100"
  >
    <path
      d="M0 100V0m100 100V0M23.12 44.08a27.55 27.55 0 0 0 24.5 33.32A2.53 2.53 0 0 1 50 79.88v2.5a2.5 2.5 0 0 1-2.62 2.53A35 35 0 0 1 50 15a34.8 34.8 0 0 1 28 14.2V17.5a2.5 2.5 0 0 1 2.5-2.5h2a2.5 2.5 0 0 1 2.5 2.5v20a2.5 2.5 0 0 1-2.5 2.5h-20a2.5 2.5 0 0 1-2.5-2.5v-2a2.5 2.5 0 0 1 2.5-2.5h9.03a27.46 27.46 0 0 0-48.4 11.08"
    />
  </svg>
  <div class="${styles.largePlayTitle}">
    <div class="${styles.largePlayTitlePre}"><%= i18n.replay %></div>
    <div class="${styles.largePlayTitleInner}" data-title></div>
  </div>
</div>
<div class="${styles.rewind} eplayer-skin-fullsize eplayer-holdable eplayer-hide-control-start">
  <span class="${styles.rewindItem}" data-rewind="backward">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <g clip-path="url(#a)">
        <path d="M30.7 1.55a1.12 1.12 0 0 1 1.6 0l1.05 1.05c.44.44.44 1.15 0 1.6l-3.3 3.3a22.5 22.5 0 0 1-.05 45h-.58A22.5 22.5 0 0 1 7.51 30.57L7.5 30c0-2.35.36-4.62 1.03-6.75.14-.45.57-.75 1.05-.75h1.51c.82 0 1.36.83 1.1 1.6a18.75 18.75 0 1 0 17.12-12.84l4.05 4.04c.44.44.44 1.15 0 1.6l-1.06 1.05c-.44.44-1.16.44-1.6 0l-7.4-7.4a1.12 1.12 0 0 1 0-1.6l7.4-7.4Z"/>
        <path d="M34.42 25.66H28.3l-.22 3.52a5.23 5.23 0 0 1 4.94.13 4.75 4.75 0 0 1 1.83 1.87c.44.79.66 1.7.66 2.71a5 5 0 0 1-.8 2.77 5.93 5.93 0 0 1-4.93 2.68 5.37 5.37 0 0 1-4.16-1.91c-.51-.6-.88-1.3-1.1-2.1l2.94-.78c.1.38.27.7.52.98s.54.5.87.66a2.53 2.53 0 0 0 3.23-1.03c.23-.38.35-.8.35-1.27a2.5 2.5 0 0 0-2.54-2.52c-.57 0-1.04.1-1.4.3-.36.18-.63.36-.8.53l-2.6-.78.5-8.62h8.84v2.86Z"/>
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h60v60H0z"/>
        </clipPath>
      </defs>
    </svg>
  </span>
  <span class="${styles.rewindItem}" data-rewind="forward">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
      <g clip-path="url(#a)">
        <path d="M27.7 1.55a1.12 1.12 0 0 1 1.6 0l7.4 7.4c.44.44.44 1.16 0 1.6l-7.4 7.4c-.44.44-1.16.44-1.6 0l-1.06-1.06a1.12 1.12 0 0 1 0-1.59l4.05-4.04-.69-.01A18.75 18.75 0 1 0 47.8 24.1c-.25-.77.3-1.6 1.1-1.6h1.52c.48 0 .9.3 1.05.75.67 2.13 1.03 4.4 1.03 6.75v.58a22.5 22.5 0 0 1-21.92 21.91l-.58.01a22.5 22.5 0 0 1-.05-45l-3.3-3.3a1.13 1.13 0 0 1 0-1.6l1.05-1.05Z"/>
        <path d="M34.42 25.66H28.3l-.22 3.52a5.23 5.23 0 0 1 4.94.13 4.75 4.75 0 0 1 1.83 1.87c.44.79.66 1.7.66 2.71a5 5 0 0 1-.8 2.77 5.93 5.93 0 0 1-4.93 2.68 5.37 5.37 0 0 1-4.16-1.91c-.51-.6-.88-1.3-1.1-2.1l2.94-.78c.1.38.27.7.52.98s.54.5.87.66a2.53 2.53 0 0 0 3.23-1.03c.23-.38.35-.8.35-1.27a2.5 2.5 0 0 0-2.54-2.52c-.57 0-1.04.1-1.4.3-.36.18-.63.36-.8.53l-2.6-.78.5-8.62h8.84v2.86Z"/>
      </g>
      <defs>
        <clipPath id="a">
          <path d="M0 0h60v60H0z"/>
        </clipPath>
      </defs>
    </svg>
  </span> 
</div>
<div class="${styles.endControls} ${styles.controlsList} eplayer-holdable">
  <div class="${styles.shareButton} ${styles.controlsItem} ${styles.button}" data-share>
    <svg
      class="${styles.buttonIcon}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        d="M20 0v20M0 0v20m14-8a2.98 2.98 0 0 0-2.17.94L7.9 10.75c.07-.24.11-.49.11-.75s-.04-.5-.1-.75l3.93-2.19A2.98 2.98 0 0 0 14 8a3 3 0 1 0-3-3c0 .26.04.5.1.75L7.18 7.94A2.98 2.98 0 0 0 5 7a3 3 0 1 0 0 6 2.98 2.98 0 0 0 2.17-.94l3.94 2.19A3 3 0 0 0 11 15a3 3 0 1 0 3-3M5 8.5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m9 5a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3m0-10a1.5 1.5 0 1 1 0 3 1.5 1.5 0 0 1 0-3"
      />
    </svg>
  </div>
  <span
    class="${styles.fullscreenButton} ${styles.controlsItem} ${styles.button}"
    data-fullscreen
  >
    <svg
      class="${styles.buttonIcon}"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 20 20"
    >
      <path
        d="M20 0v20V0ZM0 0v20V0Zm3.5 16.5v-4c0-.3-.2-.5-.5-.5h-.5c-.3 0-.5.2-.5.5V17c0 .6.4 1 1 1h4.5c.3 0 .5-.2.5-.5V17c0-.3-.2-.5-.5-.5h-4Zm13-13v4c0 .3.2.5.5.5h.5c.3 0 .5-.2.5-.5V3c0-.6-.4-1-1-1h-4.5c-.3 0-.5.2-.5.5V3c0 .3.2.5.5.5h4Zm-13 0h4c.3 0 .5-.2.5-.5v-.5c0-.3-.2-.5-.5-.5H3a1 1 0 0 0-1 1v4.5c0 .3.2.5.5.5H3c.3 0 .5-.2.5-.5v-4ZM17 12h.5c.3 0 .5.2.5.5V17c0 .6-.4 1-1 1h-4.5a.5.5 0 0 1-.5-.5V17c0-.3.2-.5.5-.5h4v-4c0-.3.2-.5.5-.5Z"
      />
    </svg>
  </span>
</div>`

// <div class="${styles.spinner}">
//   <svg
//     class="${styles.spinnerIcon}"
//     xmlns="http://www.w3.org/2000/svg"
//     viewbox="0 0 110 110"
//     >
//     <circle class="${styles.spinnerCircle}" cx="55" cy="55" r="50" />
//     <circle class="${styles.playNextProgress} ${styles.spinnerProgress}" cx="55" cy="55" r="50" data-play-next-timer />
//   </svg>
// </div>
